export default class extends Controller {
  connect() {
    App.Helpers.addAjaxSuccessHandler(this.element, this.closeSlideOut.bind(this))
  }

  closeSlideOut() {
    App.SlideOut.close({ element: this.element })
  }
}



// WEBPACK FOOTER //
// ./app/components/slide_outs/assets/javascript/slide-outs-close-on-delete-controller.js